'use client';
import { Button, Modal } from '@ethsign/ui';

import React from 'react';

import { ColorShieldIcon } from '@/components';
import { useRouter } from '@/hooks';

export const NoPermissionModal = ({ open, onOpenChange }: { onOpenChange: (open: boolean) => void; open: boolean }) => {
  const router = useRouter();
  return (
    <>
      <Modal
        open={open}
        onOpenChange={onOpenChange}
        hiddenCloseIcon
        maskClosable={false}
        footer={
          <Button
            className={'w-full'}
            onClick={() => {
              router.push('/dashboard');
            }}
          >
            back to dashboard
          </Button>
        }
        className={'md:w-[400px]'}
      >
        <div className="flex items-center flex-col justify-center">
          <ColorShieldIcon />
          <div className="text-lg font-medium text-gray-900 mt-[20px]">You don&apos;t have access to this contract</div>
          <div className="text-sm text-gray-500 mt-[8px] mb-[20px]  text-center">
            Seems like your connected address is not added as viewer of this contract. Please check your address and try
            again.
          </div>
        </div>
      </Modal>
    </>
  );
};
